export default "__VITE_ASSET__f6e2effa__"